var map = {
	"./io_deloitte_logo.svg": 16831,
	"./io_deloitteluno_logo.svg": 40399,
	"./io_io_logo.svg": 25974,
	"./io_logo.svg": 46022,
	"./io_spacefoundry_logo.svg": 61992,
	"./unbl_logo.svg": 90743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25085;